module.exports = __webpack_public_path__ + "img/not-found.6d512f14.png";